export default __webpack_public_path__ + "static/media/teenagers.3feca757.svg";